export const SCHOOL_CALENDAR_LIST_FETCHING = 'SCHOOL_CALENDAR_LIST_FETCHING';
export const SCHOOL_CALENDAR_LIST_FETCH = 'SCHOOL_CALENDAR_LIST_FETCH';
export const SCHOOL_CALENDAR_LIST_FETCH_ERROR =
  'SCHOOL_CALENDAR_LIST_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/calendarList/types.js